import React, { Component } from "react"
import { connect } from "react-redux"
import Menu from "components/menu"
import config from "./config"

class HoofCare extends Component {
  render() {
    return <Menu {...config} {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    messages: state.intl.messages.containers.features.hoofCare,
    hoofCare: state.reducers.hoofCare
  }
}

export default connect(mapStateToProps)(HoofCare)
